import {
    Component,
    EventEmitter,
    inject,
    Input,
    OnChanges,
    Output,
    Renderer2,
    SimpleChanges,
    DOCUMENT,
} from "@angular/core";

import { Context, WINDOW } from "@hermes/core-app-core";

import { trayOverlayAnimations } from "./tray-overlay.animations";

/**
 * Component in charge of displaying the gray area when a tray has an overlay.
 */
@Component({
    selector: "h-tray-overlay",
    templateUrl: "./tray-overlay.component.html",
    styleUrls: ["./tray-overlay.component.scss"],
    animations: [trayOverlayAnimations],
})
export class TrayOverlayComponent implements OnChanges {
    private renderer = inject(Renderer2);
    private window = inject<Window>(WINDOW);
    private document = inject(DOCUMENT);
    private context = inject(Context);

    /**
     * If the overlay is shown, false by default.
     */
    @Input()
    public shown: boolean = false;
    /**
     * Event sent on overlay click.
     */
    @Output()
    public overlayClick: EventEmitter<void> = new EventEmitter<void>();

    public ngOnChanges(changes: SimpleChanges): void {
        // disable page scroll when overlay is opened.
        if (changes.shown && this.context.isInBrowserMode()) {
            if (changes.shown.currentValue) {
                // we calculate the width of the scrollbar
                const scrollBarWidth =
                    this.window.innerWidth -
                    this.document.documentElement.clientWidth;

                this.onShown(scrollBarWidth);
            } else {
                this.onHide();
            }
        }
    }

    /**
     * handle body scroll when tray is open
     *
     * @param scrollBarWidth : scroll width of browser
     */
    public onShown(scrollBarWidth: number): void {
        this.renderer.setStyle(this.document.body, "overflow", "hidden");
        // Avoid width reflow
        this.renderer.setStyle(
            this.document.body,
            "padding-right",
            `${scrollBarWidth}px`,
        );
    }

    /**
     * handle body scroll when tray is close
     *
     */
    public onHide(): void {
        this.renderer.removeStyle(this.document.body, "overflow");
        // Avoid width reflow
        this.renderer.removeStyle(this.document.body, "padding-right");
    }
}
